// @ts-nocheck

import { RootState } from '../index';

// V3 Selectors
export const getAllStudies = (state: RootState) => state.studies.studies;
export const getStudyProfile = (state: RootState) => state.studies.studyProfile;
export const selectCreatedStudy = (state: RootState) => state.studies.createdStudy;
export const getStudyData = (state: RootState) => state.studies.studyData;
// Add these selectors
export const selectStudiesList = (state: RootState) => state.studies.studies;
export const selectStudiesHasMore = (state: RootState) => state.studies.hasMore;
export const selectStudiesOffset = (state: RootState) => state.studies.offset;
export const selectStudiesLimit = (state: RootState) => state.studies.limit;
export const selectIsLoadingMore = (state: RootState) => state.studies.isLoadingMore;
export const selectStudiesLoading = (state: RootState) => state.studies.isLoading;
export const selectCurrentStudy = (state: RootState) => state.studies.currentStudy;

// Common Selectors
export const getStudyId = (state: RootState) => state.studies.studyId;
export const getStudyName = (state: RootState) => state.studies.studyName;
export const getYearSelected = (state: RootState) => state.studies.yearSelected;
export const studiesLoading = (state: RootState) => state.studies.isLoading;
export const studiesError = (state: RootState) => state.studies.error;

// V2 Legacy Selectors
// export const getStudyYearProfileV2 = (state: RootState) => state.studies.yearProfile;
export const getStudyYearCompaniesV2 = (state: RootState) => state.studies.studyYearCompanies;
export const getCategoryMarketData = (state: RootState) => state.studies.categoryMarketData;

// Legacy Data Selectors
export const getCompanyData = (state: RootState) => state.studies.company;
export const getAllStudiesCompany = (state: RootState) => state.studies.studyCompanies;
